export enum WeatherRecordTypes {
  Algo = 'algo',
  Display = 'display',
}
